import { useEffect, useState } from "react";
import { mapAlgoliaProducts } from "src/hoc/repository/algolia/service/algoliaMapperService";
import { IAlgoliaProduct, IProduct } from "src/types/product";

export const useAlgoliaMapperProduct = (
  hits: IAlgoliaProduct[]
): IProduct[] => {
  const [products, setProducts] = useState<IProduct[]>([]);

  useEffect(() => {
    setProducts(mapAlgoliaProducts(hits));
  }, [hits]);

  return products;
};
